export const PAGINATION = {
  page: 1,
  size: 25
};

export const ERC20_CONFIG = {
  hash: 'https://etherscan.io/tx/{0}',
  address: 'https://etherscan.io/address/{0}',
  regexp: '^(0x|0X){1}[0-9a-fA-F]{40}$'
};
//https://bscscan.com/tx/
export const BSC_CONFIG={
  hash: 'https://bscscan.com/tx/{0}',
  address: 'https://bscscan.com/address/{0}',
  regexp: '^(0x|0X){1}[0-9a-fA-F]{40}$'
}
//https://tronscan.io/#/
export const TRC20_CONFIG={
  hash: 'https://tronscan.io/#/tx/{0}',
  address: 'https://tronscan.io/#/address/{0}',
  regexp: '^(0x|0X){1}[0-9a-fA-F]{40}$'
}

export const EOS_SERIOUS_CONFIG = {
  hash: 'https://eospark.com/MainNet/tx/{0}',
  address: 'https://eospark.com/MainNet/account/{0}',
  regexp: '^[1-5a-z]{1,12}$'
};
